// Centralised contact details for HALIPAK KİMYA & HALI HURCU.
export const PHONE_DISPLAY = "0530 109 30 19";
export const PHONE_TEL = "+905301093019";
export const WHATSAPP_NUMBER = "905301093019";
export const WHATSAPP_MESSAGE =
  "Merhaba, web sitenizden geldim. Ürünleriniz hakkında bilgi almak istiyorum.";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  WHATSAPP_MESSAGE
)}`;
